import { render, staticRenderFns } from "./FilterOptions.vue?vue&type=template&id=2f63923d&scoped=true"
import script from "./FilterOptions.vue?vue&type=script&lang=ts"
export * from "./FilterOptions.vue?vue&type=script&lang=ts"
import style0 from "./FilterOptions.vue?vue&type=style&index=0&id=2f63923d&prod&lang=scss&scoped=true"
import style1 from "./FilterOptions.vue?vue&type=style&index=1&id=2f63923d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63923d",
  null
  
)

export default component.exports